module.exports = __webpack_public_path__ + "static/img/release_title.fc89266.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/release_title.png
// module id = RNRR
// module chunks = 0